//This function remove accents and return the string in lowerCase
export const normalizaStringToLowerCase = (str: string) =>
  str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const eliminarDiacriticos = (texto: string) => {
  if (texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
};
